import { Flex, Grid, HStack, Stack, useDisclosure } from '@chakra-ui/react';
import { HelivanColor } from '../helivan/HelivanColor';
import { HelivanText } from '../helivan/HelivanText';
import { HelivanButton } from '../helivan/HelivanButton';
import { RiAddCircleLine } from 'react-icons/ri';
import { EvaluationsCreateNewModal } from './EvaluationsCreateNewModal';
import {
  ProjectStatus,
  ProjectType,
  useProjectsQuery,
} from '../../generated/graphql';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { ProjectCard } from '../Projects/ProjectCard';
import { HelivanLoading } from '../HelivanLoading';
import { EvaluationCard } from '../Projects/EvaluationCard';

export const Evaluations = () => {
  const { data, loading } = useProjectsQuery();
  const evaluations =
    data?.user?.currentOrganization?.initialProjects?.filter(
      (project) => project.type === ProjectType.Evaluation
    ) ?? [];
  const navigate = useNavigate();

  // Optimize navigation handler with useCallback
  const handleProjectClick = useCallback(
    (id: string) => {
      navigate(`/evaluations/${id}`);
    },
    [navigate]
  );

  const { isOpen, onOpen, onClose } = useDisclosure();

  return loading ? (
    <HelivanLoading />
  ) : (
    <Stack
      width="full"
      height="full"
      spacing={0}
      bg={HelivanColor.background.primary}
      border="1px solid"
      borderColor={HelivanColor.border.primary}
      borderRadius="8px"
      overflow="hidden"
    >
      <Flex
        width="full"
        px="30px"
        py="16px"
        borderBottomColor={HelivanColor.border.primary}
        bg="white"
        borderTopRadius="12px"
        borderBottomWidth="1px"
        justifyContent="space-between"
        alignItems="center"
      >
        <HelivanText variant="largeSubheader">Evaluations</HelivanText>
        <HelivanButton variant="green" size="sm" onClick={onOpen}>
          <HStack spacing={1}>
            <RiAddCircleLine color="#245B4A" size={16} />
            <HelivanText colorOverride="#245B4A" variant="largeBody+">
              Create New
            </HelivanText>
          </HStack>
        </HelivanButton>
        <EvaluationsCreateNewModal isOpen={isOpen} onClose={onClose} />
      </Flex>
      <Flex
        width="full"
        height="full"
        flexDirection="column"
        gap="24px"
        pt={10}
      >
        <Stack
          spacing={2}
          px={6}
          alignItems="center"
          overflowY="scroll"
          width="full"
          justifyContent={evaluations.length > 0 ? undefined : 'center'}
        >
          {evaluations.length > 0 ? (
            <Grid
              templateColumns={[
                'repeat(3, 1fr)',
                'repeat(3, 1fr)',
                'repeat(3, 1fr)',
                'repeat(3, 1fr)',
                'repeat(3, 1fr)',
                'repeat(4, 1fr)',
              ]}
              gap={8}
            >
              {evaluations.map((project) => {
                return (
                  <EvaluationCard
                    onClick={
                      project.status === ProjectStatus.Completed
                        ? () => handleProjectClick(project.id)
                        : undefined
                    }
                    dateCreated={project.createdAt ?? ''}
                    id={project.id}
                    numberModels={project.numberTwins ?? 0}
                    title={project.topicShortened ?? project.topic}
                    key={project.id}
                    status={project.status}
                  />
                );
              })}
            </Grid>
          ) : (
            <HelivanText variant="largeBody">No results found</HelivanText>
          )}

          <HelivanText variant="largeSubheader" colorOverride="transparent">
            Space
          </HelivanText>
          <HelivanText variant="largeSubheader" colorOverride="transparent">
            Space
          </HelivanText>
        </Stack>
      </Flex>
    </Stack>
  );
};
